import React from 'react';
import PropTypes from 'prop-types';
import s from './CricketStats.scss';
import Link from '../../../../../components/Link/Link';
import CricketIPLCapsStats from './CricketIPLCapsStats';
import { TOI_IMAGE_DOMAIN } from '../../../../../constants';

const CricketIPLCapsStatsWrapper = ({ sectionItem }) => {
  const {
    cricketCapsStats = [],
    tournamentName,
    activeTab,
    capTitle,
    pageUrl,
    capPrevtitle,
  } =
    sectionItem || {};
  const thumbslist = cricketCapsStats?.playerthumbs?.data;
  const defaultThumb = `${TOI_IMAGE_DOMAIN}/thumb/msid-81945120,width-50,height-100/81945120.jpg`;

  const tableDataStats =
    cricketCapsStats && activeTab ? cricketCapsStats[activeTab] : [];
  const orangeCapURL = activeTab && activeTab === 'Purple' ? pageUrl : '';
  const purpleCapURL = activeTab && activeTab === 'Orange' ? pageUrl : '';

  return (
    <>
      <div className={`${s.stats_page_cont} ${s.stats_page_wrapper}`}>
        <div className={s.tabwapWrap}>
          <ul className={s.tabwap}>
            <li
              className={`${s.tab} ${
                activeTab && activeTab === 'Orange' ? s.active : ''
              }`}
            >
              {orangeCapURL ? (
                <Link to={orangeCapURL}>
                  <span>ORANGE CAP</span>
                </Link>
              ) : (
                <span>ORANGE CAP</span>
              )}
            </li>
            <li
              className={`${s.tab} ${
                activeTab && activeTab === 'Purple' ? s.active : ''
              }`}
            >
              {purpleCapURL ? (
                <Link to={purpleCapURL}>
                  <span>Purple CAP</span>
                </Link>
              ) : (
                <span>Purple CAP</span>
              )}
            </li>
          </ul>
        </div>
        {tableDataStats &&
          Array.isArray(tableDataStats) &&
          tableDataStats.length > 0 &&
          tableDataStats.map((tablecapsData, index) => {
            const topLeaderData =
              tablecapsData &&
              tablecapsData?.leaderboard &&
              Array.isArray(tablecapsData?.leaderboard) &&
              tablecapsData.leaderboard.length > 0
                ? tablecapsData.leaderboard[0]
                : {};
            const prevCapTitle = `${tablecapsData?.series_short_name?.replace(
              ',',
              '',
            )} - ${activeTab} Cap Winner`;
            return (
              <>
                {tablecapsData && (
                  <CricketIPLCapsStats
                    tableData={tablecapsData}
                    topLeaderData={topLeaderData}
                    activeTab={activeTab}
                    thumbslist={thumbslist}
                    defaultThumb={defaultThumb}
                    tournamentName={tournamentName}
                    capTitle={index === 0 ? capTitle : prevCapTitle}
                  />
                )}
                {index !== tableDataStats.length - 1 && (
                  <div className={s.tableSeparator} />
                )}
              </>
            );
          })}
      </div>
    </>
  );
};

CricketIPLCapsStatsWrapper.propTypes = {
  sectionItem: PropTypes.shape({
    cricketCapsStats: PropTypes.array,
    tournamentName: PropTypes.string,
  }),
};

CricketIPLCapsStatsWrapper.defaultProps = {
  sectionItem: {
    cricketCapsStats: [],
    tournamentName: '',
  },
};

export default CricketIPLCapsStatsWrapper;
